module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.c7b158e3.ttf";